import type { KunciSlot } from "@/modules/media/domain/slot"

export type KodeHalamanSistem = "401" | "403" | "404" | "429" | "500" | "pemeliharaan" | "offline"

export type IkonAksi = "beranda" | "bantuan" | "blog" | "kontak" | "paket" | "muat-ulang" | "kembali" | "masuk"

export interface AksiHalaman {
  label: string
  ikon?: IkonAksi
  href?: string
  aksi?: "muat-ulang" | "coba-lagi" | "kembali"
  utama?: boolean
}

export interface KonfigurasiHalaman {
  kode: KodeHalamanSistem
  lencana: string
  slot: KunciSlot
  judul: string
  deskripsi: string
  aksi: AksiHalaman[]
}

export const HALAMAN_SISTEM: Record<KodeHalamanSistem, KonfigurasiHalaman> = {
  "401": {
    kode: "401",
    lencana: "401",
    slot: "sistem-401",
    judul: "Kamu perlu masuk dulu",
    deskripsi: "Halaman ini hanya bisa dibuka setelah masuk. Silakan masuk, lalu coba lagi.",
    aksi: [{ label: "Kembali ke beranda", ikon: "beranda", href: "/" }],
  },
  "403": {
    kode: "403",
    lencana: "403",
    slot: "sistem-403",
    judul: "Kamu tidak punya akses",
    deskripsi: "Akunmu tidak punya izin untuk membuka halaman ini. Kalau menurutmu ini keliru, hubungi kami.",
    aksi: [
      { label: "Kembali ke beranda", ikon: "beranda", href: "/" },
      { label: "Hubungi kami", ikon: "kontak", href: "/contact" },
    ],
  },
  "404": {
    kode: "404",
    lencana: "404",
    slot: "sistem-404",
    judul: "Halaman tidak ditemukan",
    deskripsi: "Alamatnya mungkin salah ketik atau halamannya sudah dipindahkan. Mulai lagi dari salah satu tujuan di bawah ini.",
    aksi: [
      { label: "Beranda", ikon: "beranda", href: "/" },
      { label: "Pusat bantuan", ikon: "bantuan", href: "/help" },
      { label: "Blog", ikon: "blog", href: "/blog" },
    ],
  },
  "429": {
    kode: "429",
    lencana: "429",
    slot: "sistem-429",
    judul: "Terlalu banyak permintaan",
    deskripsi: "Kamu terlalu cepat mengirim permintaan. Tunggu sebentar lalu coba lagi, biasanya hanya butuh beberapa detik.",
    aksi: [{ label: "Coba lagi", ikon: "muat-ulang", aksi: "muat-ulang", utama: true }],
  },
  "500": {
    kode: "500",
    lencana: "500",
    slot: "sistem-500",
    judul: "Terjadi gangguan di sisi kami",
    deskripsi: "Ada yang tidak berjalan semestinya dan itu bukan salahmu. Tim kami sudah diberi tahu. Coba lagi sebentar lagi.",
    aksi: [
      { label: "Coba lagi", ikon: "muat-ulang", aksi: "coba-lagi", utama: true },
      { label: "Kembali ke beranda", ikon: "beranda", href: "/" },
    ],
  },
  pemeliharaan: {
    kode: "pemeliharaan",
    lencana: "Pemeliharaan",
    slot: "sistem-pemeliharaan",
    judul: "Sedang dalam pemeliharaan",
    deskripsi: "Kami sedang merapikan beberapa hal supaya layanan lebih baik. Server yang sudah berjalan tetap aman dan tidak terganggu.",
    aksi: [{ label: "Muat ulang", ikon: "muat-ulang", aksi: "muat-ulang", utama: true }],
  },
  offline: {
    kode: "offline",
    lencana: "Offline",
    slot: "sistem-offline",
    judul: "Kamu sedang offline",
    deskripsi: "Perangkatmu tidak terhubung ke internet. Periksa koneksi lalu coba lagi, halaman akan terbuka begitu koneksi kembali.",
    aksi: [{ label: "Coba lagi", ikon: "muat-ulang", aksi: "muat-ulang", utama: true }],
  },
}

export function kodeHalamanValid(nilai: string): nilai is "401" | "403" | "429" {
  return nilai === "401" || nilai === "403" || nilai === "429"
}

export function bacaDetikTunggu(mentah: string | string[] | undefined, maks = 600): number {
  const nilai = Number.parseInt(Array.isArray(mentah) ? (mentah[0] ?? "") : (mentah ?? ""), 10)
  if (!Number.isFinite(nilai) || nilai <= 0) return 0
  return Math.min(nilai, maks)
}

export function labelSisaWaktu(detik: number): string {
  if (detik <= 0) return ""
  if (detik < 60) return `${detik} detik`
  return `${Math.ceil(detik / 60)} menit`
}
